// In future we can make this configurable through pluginOptions
export const NUDGE_AFTER_DOC_CHANGE_DURATION = 3 * 1000; // 3 seconds
export const NUDGE_DURATION = 2 * 60 * 1000; // 2 minutes
export const FIRST_NUDGE_CHECK_DURATION = 8 * 1000; // 8 seconds
